export { default as ArrowLeftIcon } from './assets/arrow-left-icon.svg';
export { default as BadgeNewIcon } from './assets/badge-new-icon.svg';
export { default as BagIcon } from './assets/bag-icon.svg';
export { default as BantNewIcon } from './assets/bant-new-icon.svg';
export { default as ChartPieSliceIcon } from './assets/chart-pie-slice.svg';
export { default as ChatBubble } from './assets/chat-bubble.svg';
export { default as ChatsCircleIcon } from './assets/chats-circle-icon.svg';
export { default as CheckIcon } from './assets/check-icon.svg';
export { default as CheckSquareIcon } from './assets/check-square-icon.svg';
export { default as ChevronBottomIcon } from './assets/chevron-bottom-icon.svg';
export { default as ChevronRightIcon } from './assets/chevron-right-icon.svg';
export { default as CircleWavyCheckIcon } from './assets/circle-wavy-check-icon.svg';
export { default as CircleWavyCheckOutlineIcon } from './assets/circle-wavy-check-outline-icon.svg';
export { default as ColorLeetcodeIcon } from './assets/color-leetcode-icon.svg';
export { default as ColorLinkedinIcon } from './assets/color-linkedin-icon.svg';
export { default as ColorTelegramIcon } from './assets/color-telegram-icon.svg';
export { default as ColorYoutubeIcon } from './assets/color-youtube-icon.svg';
export { default as CopyIcon } from './assets/copy-icon.svg';
export { default as CppLanguageIcon } from './assets/cpp-language-icon.svg';
export { default as CreditCardMasterCardIcon } from './assets/credit-card-mc-icon.svg';
export { default as CreditCardMirIcon } from './assets/credit-card-mir-icon.svg';
export { default as CreditCardVisaIcon } from './assets/credit-card-visa-icon.svg';
export { default as CrownSimpleIcon } from './assets/crown-simple-icon.svg';
export { default as CtoGradeIcon } from './assets/cto-grade-icon.svg';
export { default as CSharpLanguageIcon } from './assets/csharp-language-icon.svg';
export { default as DotsThreeVerticalIcon } from './assets/dots-three-vertical-icon.svg';
export { default as Favicon } from './assets/favicon.svg';
export { default as FireIcon } from './assets/fire-icon.svg';
export { default as FreeIcon } from './assets/free-icon.svg';
export { default as GlobeIcon } from './assets/globe-icon.svg';
export { default as GoIcon } from './assets/go-icon.svg';
export { default as GolangIcon } from './assets/golang-icon.svg';
export { default as GoLanguageIcon } from './assets/go-language-icon.svg';
export { default as HeaderMenuIcon } from './assets/header-menu-icon.svg';
export { default as HeadsetIcon } from './assets/headset-icon.svg';
export { default as HexagonLineCircleIcon } from './assets/hexagon-line-circle-icon.svg';
export { default as InfoIcon } from './assets/info-icon.svg';
export { default as InfoOutlineIcon } from './assets/info-outline-icon.svg';
export { default as JavaLanguageIcon } from './assets/java-language-icon.svg';
export { default as JavaScriptLanguageIcon } from './assets/javascript-language-icon.svg';
export { default as JuniorGradeIcon } from './assets/junior-grade-icon.svg';
export { default as KotlinLanguageIcon } from './assets/kotlin-language-icon.svg';
export { default as LeadGradeIcon } from './assets/lead-grade-icon.svg';
export { default as LockClosedIcon } from './assets/lock-closed-icon.svg';
export { default as LockIcon } from './assets/lock-icon.svg';
export { default as MagicWandIcon } from './assets/magic-wand-icon.svg';
export { default as MailIcon } from './assets/mail-icon.svg';
export { default as MiddleGradeIcon } from './assets/middle-grade-icon.svg';
export { default as MinusIcon } from './assets/minus-icon.svg';
export { default as MoreVertIcon } from './assets/more-vert-icon.svg';
export { default as NeuralIcon } from './assets/neural-icon.svg';
export { default as NewcomerGradeIcon } from './assets/newcomer-grade-icon.svg';
export { default as SurveyAlgorithmIcon } from './assets/survey-algorithm-icon.svg';
export { default as SurveyResumeIcon } from './assets/survey-resume-icon.svg';
export { default as SurveySeventeenPlusHoursIcon } from './assets/survey-seventeen-plus-hours-icon.svg';
export { default as SurveySoftSkillsIcon } from './assets/survey-soft-skills-icon.svg';
export { default as SurveySixPlusMonthsIcon } from './assets/survey-six-plus-months-icon.svg';
export { default as SurveySqlIcon } from './assets/survey-sql-icon.svg';
export { default as SurveyStackIcon } from './assets/survey-stack-icon.svg';
export { default as SurveySystemDesignIcon } from './assets/survey-system-design-icon.svg';
export { default as SurveyYoutubeIcon } from './assets/survey-youtube-icon.svg';
export { default as PercentIcon } from './assets/percent-icon.svg';
export { default as PlusIcon } from './assets/plus-icon.svg';
export { default as ProjectorAnalyticsIcon } from './assets/projector-analytics-icon.svg';
export { default as PythonLanguageIcon } from './assets/python-language-icon.svg';
export { default as ReloadIcon } from './assets/reload-icon.svg';
export { default as SendTelegramIcon } from './assets/send-telegram-icon.svg';
export { default as SeniorGradeIcon } from './assets/senior-grade-icon.svg';
export { default as SquaresFourIcon } from './assets/squares-four-icon.svg';
export { default as StarIcon } from './assets/star-icon.svg';
export { default as StarV2Icon } from './assets/star-v2-icon.svg';
export { default as Stepper2Icon } from './assets/stepper2-icon.svg';
export { default as StudentGradeIcon } from './assets/student-grade-icon.svg';
export { default as SustemDesignIcon } from './assets/system-design-icon.svg';
export { default as SystemDesignIcon } from './assets/system-design-icon.svg';
export { default as SwiftLanguageIcon } from './assets/swift-language-icon.svg';
export { default as TelegramIcon } from './assets/telegram-icon.svg';
export { default as TextAlignLeftIcon } from './assets/text-align-left-icon.svg';
export { default as ThumbsDownIcon } from './assets/thumbs-down-icon.svg';
export { default as ThumbsUpIcon } from './assets/thumbs-up-icon.svg';
export { default as TrophyIcon } from './assets/trophy-icon.svg';
export { default as UserIcon } from './assets/user.svg';
export { default as VideoCameraIcon } from './assets/video-camera-icon.svg';
export { default as VideoPlayIcon } from './assets/video-play-icon.svg';
export { default as WarningCircleIcon } from './assets/warning-circle-icon.svg';
export { default as XMarkIcon } from './assets/x-mark-icon.svg';
export { default as YandexCircleIcon } from './assets/yandex-circle-icon.svg';
export { default as TypeScriptLanguageIcon } from './assets/typescript-language-icon.svg';
